import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { RequisitionFlow } from '@core/requisitions-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<RequisitionFlow>()(
  'RequisitionsFlows',
  {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id!);

      return {
        setAsDefault: actions.updateOnePessimistic,
        setAsDefaultSuccess: actions.updateOnePessimisticSuccess,
        setAsDefaultFailed: actions.updateOnePessimisticFailed,
      };
    },
  },
);

export {
  actions as RequisitionsFlowsActions,
  selectors as RequisitionsFlowsSelectors,
  namespace as RequisitionsFlowsNamespace,
  reducer as RequisitionsFlowsReducer,
};
